import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getEvents } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Events = () => {
  // ✅ Use TanStack Query (React Query v5 syntax)
  const { data: eventsData } = useQuery({
    queryKey: ["homeEvents"],
    queryFn: getEvents,
  });

  // ✅ Month Names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // ✅ Fallback static data when no events are available
  const emptyArray = [
    {
      title: "Event Title",
      description: "Event Description",
      date: "DD.MM",
      time: "00:00",
      venue: "School",
      eventImg: "/Images/events.jpg",
    },
    {
      title: "Event Title",
      description: "Event Description",
      date: "DD.MM",
      time: "00:00",
      venue: "School",
      eventImg: "/Images/events.jpg",
    },
    {
      title: "Event Title",
      description: "Event Description",
      date: "DD.MM",
      time: "00:00",
      venue: "School",
      eventImg: "/Images/events.jpg",
    },
  ];

  // ✅ React Slick settings (unchanged layout)
  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  // ✅ Use fallback safely
  const events =
    Array.isArray(eventsData) && eventsData.length > 0
      ? eventsData
      : emptyArray;
  const hasRealData = Array.isArray(eventsData) && eventsData.length > 0;

  return (
    <>
      <div className="eventbg">
        <Slider {...settings}>
          {events.map((item, index) => {
            // ✅ Format date (only if real API date exists)
            const dateObj =
              item.date && !item.date.includes("DD")
                ? new Date(item.date)
                : null;
            const month = dateObj ? monthNames[dateObj.getMonth()] : "MM";
            const eventDate = dateObj ? dateObj.getDate() : "DD";

            return (
              <div className="item" key={index}>
                <div className="homeeventbox">
                  <div className="homeeventboximg">
                    <p>
                      <span>
                        <LazyLoad>
                          <img
                            src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/location.gif"
                            className="img-fluid"
                            alt="St. Joseph’s school, Barhalganj"
                          />
                        </LazyLoad>
                        {item.venue} / {item.time}
                      </span>
                    </p>

                    {item.images && item.images.length > 0 ? (
                      <LazyLoad
                        offset={10}
                        placeholder={
                          <img
                            src="https://webapi.entab.info/api/image/SJSKBUP/public/Images/events.jpg"
                            alt="Loading..."
                            className="img-fluid"
                          />
                        }>
                        <img
                          src={`https://webapi.entab.info/api/image/${item.images}`}
                          className="img-fluid"
                          alt={item.title || "Event"}
                        />
                      </LazyLoad>
                    ) : (
                      <img
                        src={
                          "https://webapi.entab.info/api/image/SJSKBUP/public/Images/events.jpg"
                        }
                        className="img-fluid"
                        alt={item.title || "Event"}
                      />
                    )}
                  </div>

                  <div className="homeeventboxdesc">
                    <div className="homeeventboxtitle">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                      <div className="homeeventboxbottom">
                        <span>
                          {hasRealData ? `${eventDate}, ${month}` : "DD, MM"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>

        <button className="button">
          <Link to="/Eventinner">Read More</Link>
        </button>
      </div>
    </>
  );
};

export default Events;
